// constants.js

export const NUM_SEARCH_ELEMENTS_LIMIT = 100;
export const NUM_SEARCH_INDICES_LIMIT_TO_SHOW = 4;
export const NUM_SEARCH_ELEMENTS_LIMIT_TO_SHOW = 3;

export const TYPE_ID = {
	SECURITY: '1',
	INDEX: '2',
	FUND: '4',
	MANAGER: '10',
	OPTIONS: '7',
	COMP_PAGE: '5',
};

export const SUB_TYPE_ID = {
	STOCK: '1',
	ABROAD_FUND: '44',
	ABROAD_BOND: '45',
	BOND: '5',

	NON_EXISTS: '991',
};

export const MAGNA_TYPE = {
	BOND: '1',
};

export const TASE_TYPES = {
	IMITATING: 'IMITATING',
	LEVERAGED: 'LEVERAGED',
	SHORT: 'SHORT',
};
